import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Typography, Box, Container } from '@mui/material';
import { Controller, useForm, FormProvider } from 'react-hook-form';

import { fileActions, addTitleLegoCurrent } from '../../store/actions';
import { coreFunctions, IsDevice } from '../../utils';
import {
  Buttons,
  CustomLoadingOverlay,
  GenericContainerForm,
  Alert,
  GenericContainer,
} from '../../components';
import { InputField } from '../../components/InputField';
import { useTranslation } from 'react-i18next';
import { fileRequests } from 'services';

const ControlContainer = ({ children }) => {
  return (
    <Box boxShadow={5} p={2} my={3} mx={1}>
      {children}
    </Box>
  );
};

export default function SatisfactionSurvey({ nextView }) {
  const formMethods = useForm();
  const {
    control,
    reset,
    handleSubmit,
    setValue,
    formState,
    register,
    clearErrors,
    setFocus,
    formState: { errors, submitCount },
  } = useForm({ mode: 'onBlur' });

  const [propsStage, setPropsStage] = useState({
    title: 'Encuesta',
    description: '',
    buttonText: 'Enviar',
  });
  const [questions, setQuestions] = useState([]);
  const [loadView, setLoadView] = useState(false);
  const file = useSelector((state) => state.FileInfo);
  const surveyFile = useSelector((state) => state.GetSurveyQuestions);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    if (file.items != undefined) {
      let title = file.items.Stage.Properties.find((el) => el.Name === 'TitleP2');
      let description = file.items.Stage.Properties.find((el) => el.Name === 'DescriptionP2');
      let buttonText = file.items.Stage.Properties.find((el) => el.Name === 'ButtonTextP2');
      let surveyName = file.items.Stage.Properties.find((el) => el.Name === 'SurveyName');

      dispatch(addTitleLegoCurrent(title?.Value));
      dispatch(fileActions.GetSurveyQuestions({ SurveyName: surveyName.Value }));
      setPropsStage({
        title: title?.Value || "Encuesta",
        description: description?.Value || "",
        buttonText: buttonText?.Value || "Enviar",
      });
    }
  }, [file]);

  useEffect(() => {
    setLoadView(surveyFile.loading);
    if (surveyFile.items != undefined) {
      const SurvQuestions = surveyFile.items;
      let newArray = setGroupNames(SurvQuestions.QuestionGroups);
      setQuestions(newArray);
      setLoadView(false);
    } else if (file.error != undefined) {
      setLoadView(false);
    }
  }, [surveyFile]);

  const setGroupNames = (array, disabled = false) => {
    //console.log('arrayData::', array, questions);
    const newGroup = array.map((group) => {
      return {
        groupTitle: group.Name,
        folio: file.items.Id,
        description: group.Description,
        llave: group.Id,
        questions: group.Questions.map((qn) => {
          return {
            ...qn,
            GroupName: group.Name,
            Value: qn.Metadata != undefined && qn.Metadata != null ? qn.Metadata.Value : '',
            DefaultValue: null,
            Captured: null,
            Disabled: disabled, // Parametro que va indicar que es de solo lectura el campo.
            Visible: qn.Visible === undefined || qn.Visible === null ? true : qn.Visible,
            //Required: true
          };
        }),
      };
    });
    return newGroup;
  };

  let SubmitForm = async (formData) => {
    try {
      //console.log('EntroasubmitBUENO::', formData);
      const generalMetadata = questions.map((itemGroup, i) => {
        let itemsQuestions = itemGroup.questions.map((itemQuestion, i) => {
          return {
            ...itemQuestion,
            Value: itemQuestion.Visible ? formData[`${itemQuestion.Id}`] : null,
          };
        });
        return {
          ...itemGroup,
          questions: itemsQuestions,
        };
      });
      //console.log("generalMetadata::", generalMetadata)

      let payload = {
        SurveyId: surveyFile.items?.SurveyId,
        FileId: file.items?.Id,
        WorkflowInstanceId: file.items?.WorkFlow?.WorkflowInstance?.Id,
        Answers: coreFunctions.GetResponsens(generalMetadata),
      };

      console.log('Payload::', payload);

      setLoadView(true);
      await fileRequests.RegisterSurveyAnswers(payload);
      reset();
      nextView('END');
    } catch (error) {
      console.log('TryError::error.message::', error, error.message);
      setLoadView(false);
      Alert({
        icon: 'error',
        text: error.message,
        okbtntext: t('general_accept'),
      });
    }
  };

  //console.log('questions::', questions);

  useEffect(() => {
    const firstError = Object.keys(errors).reduce((field, a) => {
      console.log('Erros::field, a:: ', field, a);
      return !!errors[field] ? field : a;
    }, null);

    if (firstError) setFocus(firstError);
  }, [errors, setFocus, submitCount]);

  const content = (
    <Container>
      <FormProvider {...formMethods}>
        {loadView && <CustomLoadingOverlay active={loadView} text={t('general_loading_message')} />}
        <Typography variant="h6" gutterBottom>
          {propsStage.description}
        </Typography>

        {questions?.length > 0 ? (
          <GenericContainerForm>
            {questions.length > 0 &&
              questions.map((itemGroup, indexGroup) =>
                itemGroup.questions.every((question) => !question.Visible) ? null : (
                  <Box key={indexGroup}>
                    <Typography variant="h6" gutterBottom>
                      {itemGroup.Description}
                    </Typography>
                    {itemGroup.questions?.map((itemInput, indexInput) => {
                      if (itemInput.Visible === false) return null;
                      // console.log('itemInputitemInput', itemInput)
                      switch (itemInput.QuestionType.toUpperCase()) {
                        case 'TEXTO':
                          return (
                            <ControlContainer>
                              <Controller
                                control={control}
                                name={`${itemInput.Id}`}
                                render={({ field: { ref, ...restFields } }) => (
                                  <InputField
                                    inputType="text"
                                    control={control}
                                    register={register}
                                    name={`${itemInput.Id}`}
                                    regexGeneric={itemInput.RegularExpression}
                                    label={itemInput.Description}
                                    validations={{ required: itemInput.Required }}
                                    defaultValue={itemInput.Value}
                                    error={!!formState.errors[`${itemInput.Id}`]}
                                    helperText={formState.errors[`${itemInput.Id}`]?.message}
                                    required={itemInput.Required}
                                    disabled={itemInput.Disabled}
                                    placeholder={itemInput.Description}
                                  />
                                )}
                              />
                            </ControlContainer>
                          );
                        case 'TEXTAREA':
                          return (
                            <ControlContainer>
                              <InputField
                                inputType="text"
                                control={control}
                                register={register}
                                multiline={true}
                                minRows={3}
                                name={`${itemInput.Id}`}
                                regexGeneric={itemInput.RegularExpression}
                                label={itemInput.Description}
                                validations={{ required: itemInput.Required }}
                                defaultValue={itemInput.Value}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={formState.errors[`${itemInput.Id}`]?.message}
                                required={itemInput.Required}
                                disabled={itemInput.Disabled}
                                placeholder={itemInput.Description}
                              />
                            </ControlContainer>
                          );
                        case 'ESCALA':
                          return (
                            <ControlContainer>
                              <InputField
                                inputType="escala"
                                control={control}
                                name={`${itemInput.Id}`}
                                label={itemInput.Description}
                                validations={{ required: itemInput.Required }}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={formState.errors[`${itemInput.Id}`]?.message}
                                required={itemInput.Required}
                                onSelect={(e, value) => {
                                  console.log(
                                    'RATING Value: ',
                                    value,
                                    ' itemInput.Id : ',
                                    itemInput.Id,
                                  );
                                  clearErrors(`${itemInput.Id}`);
                                  setValue(`${itemInput.Id}`, value);
                                }}
                                disabled={itemInput.Disabled}
                              />
                            </ControlContainer>
                          );
                        default:
                          return null;
                      }
                    })}
                  </Box>
                ),
              )}
          </GenericContainerForm>
        ) : null}
      </FormProvider>
    </Container>
  );

  const actions = (
    <Buttons
      onClickConfirm={handleSubmit((e) => SubmitForm(e))}
      ConfirmButtonText={propsStage.buttonText}
      marginBottom={IsDevice().IsIOS ? 10 : 2}
    />
  );

  return (
    <GenericContainer>
      {content}
      {actions}
    </GenericContainer>
  );
}
